

import { pdMixin } from '@/mixin/pd/pdMixin'

import InfoContainer from '~/components/common/template/InfoContainer.vue'
import Tooltip from '~/components/common/tooltip/Tooltip.vue'

export default {
  components: {
    InfoContainer,
    Tooltip
  },
  mixins: [pdMixin],
  props: {
    type: {
      type: String,
      default: ''
    },
    bnfInfo: { // 고객 혜택 정보
      type: Object,
      default: () => {
        return {}
      }
    },
    cpnInfo: { // 쿠폰 정보
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      cpnCnt: 0, // 쿠폰갯수
      maxBnfAm: 0, // 적립 최댓값
      payBnf: [], // 결제 혜택
      cashBnfList: [] // 포인트 혜택 리스트
    }
  },
  computed: {

  },
  mounted () {
    if (this.type === 'bnf') {
      this.payBnf = []
      this.cashBnfList = []
      if (this.bnfInfo.success) {
        this.bnfInfo.data.forEach((item, idx) => {
          const obj = {
            idx,
            cndValSeCd: item.cndValSeCd,
            cn: item.spyMthCd === '10' ? this.getBnfRtCn(item) : this.getBnfAmtCn(item), // 10 : 정률 / 20 : 정액
            bnfTitl: item.bnfTitl,
          }
          if (item.cndValSeCd === '10') { // 결제 혜택 정보일 경우
            this.payBnf.push(item)
          } else {
            this.maxBnfAm = Math.max(this.maxBnfAm, parseInt(item.maxBnfAm))
            this.cashBnfList.push(obj)
          }
        })
        console.log('bnfList test ', this.maxBnfAm, this.payBnf, this.cashBnfList)
      } else {
        console.log('bnfList error :', this.bnfInfo.message)
      }
    } else if (this.type === 'cpn') {
      this.cpnCnt = this.cpnInfo.data.length
    }
  },
  methods: {
    // 정률 혜택 설명 가져오기
    getBnfRtCn (bnf) {
      switch (bnf.cndValSeCd) {
        case '01' :
          // 장바구니 금액 조건
          return `지금 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, 포인트 ${bnf.acmRte}% 적립<br>${this.getExtraInfo(bnf)}`
        case '02' :
          // 브랜드 구매 조건
          return `지금 해당 브랜드 구매 시, 포인트 ${bnf.acmRte}% 적립<br>${this.getExtraInfo(bnf)}`
        case '03' :
          // 카테고리 구매 조건
          return `지금 해당 카테고리 구매 시, 포인트 ${bnf.acmRte}% 적립<br>${this.getExtraInfo(bnf)}`
        case '04' :
          // 기획전 구매 조건
          return `지금 해당 기획전 구매 시, 포인트 ${bnf.acmRte}% 적립<br>${this.getExtraInfo(bnf)}`
        case '05' :
          // 브랜드 구매 / 장바구니 금액 조건
          return `지금 해당 브랜드 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, 포인트 ${bnf.acmRte}% 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '06' :
          // 카테고리 구매 / 장바구니 금액 조건
          return `지금 해당 카테고리 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, 포인트 ${bnf.acmRte}% 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '07' :
          // 기획전 구매 / 장바구니 금액 조건
          return `지금 해당 기획전 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, 포인트 ${bnf.acmRte}% 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '08' :
          // 첫구매 조건
          return `첫 구매 시, 포인트 ${bnf.acmRte}% 적립<br>${this.getExtraInfo(bnf)}`
        case '09' :
          // 첫구매 / 장바구니 금액 조건
          return `첫구매 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, 포인트 ${bnf.acmRte}% 추가 적립<br>${this.getExtraInfo(bnf)}`
        default :
          // 결제혜택 내용(카드사 무이자) pyCn ? pyBnf
          return this.unescape(bnf.pyBnf)
      }
    },

    // 정액 혜택 설명 가져오기
    getBnfAmtCn (bnf) {
      switch (bnf.cndValSeCd) {
        case '01' :
          // 장바구니 금액 조건
          return `지금 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '02' :
          // 브랜드 구매 조건
          return `지금 해당 브랜드 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '03' :
          // 카테고리 구매 조건
          return `지금 해당 카테고리 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '04' :
          // 기획전 구매 조건
          return `지금 해당 기획전 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '05' :
          // 브랜드 구매 / 장바구니 금액 조건
          return `지금 해당 브랜드 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '06' :
          // 카테고리 구매 / 장바구니 금액 조건
          return `지금 해당 카테고리 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '07' :
          // 기획전 구매 / 장바구니 금액 조건
          return `지금 해당 기획전 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '08' :
          // 첫구매 조건
          return `첫 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        case '09' :
          // 첫구매 / 장바구니 금액 조건
          return `첫구매 ${this.numberComma(bnf.spbkAm)}원 이상 구매 시, ${this.numberComma(bnf.maxBnfAm)}P 추가 적립<br>${this.getExtraInfo(bnf)}`
        default :
          // 결제혜택 내용(카드사 무이자)
          return this.unescape(bnf.pyBnf)
      }
    },

    getExtraInfo (item) {
      let maxAm = item.spyMthCd === '10' ? '(최대 ' + this.numberComma(item.maxBnfAm) + 'P, ' : '('

      if (this.isNotEmpty(item.ofrAplStDtm) && this.isNotEmpty(item.ofrAplEdDtm)) {
        maxAm += item.ofrAplStDtm.slice(5, 10).replace('-', '/') + '~' + item.ofrAplEdDtm.slice(5, 10).replace('-', '/') + ')'
      }
      return maxAm
    }

  }
}
